exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-back-button{display:block;width:24px;height:24px;margin:16px;background-color:rgba(0,0,0,0);border:none;border-radius:50%;border:none;overflow:hidden;-webkit-transition:all ease .2s;-o-transition:all ease .2s;transition:all ease .2s;cursor:pointer}@media(min-width: 1160px){.nav-back-button{width:48px;height:48px;padding:12px;background-color:#eff5fa}.nav-back-button:hover{background-color:#dee9f4}}.nav-back-button svg{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/nav-back-button/style.scss
// module id = 1374
// module chunks = 57